import { ERROR_PAGE_CONTENTS } from '@constants/params';

export const getErrorContent = (error) => {
  if (!error) return;

  const code = parseInt(Object.prototype.toString.call(error) === '[object Object]' ? error.code : error);
  const errorObject = ERROR_PAGE_CONTENTS[code] || ERROR_PAGE_CONTENTS.default;

  return {
    ...errorObject,
    ...(!isNaN(code) && { code }),
  };
};
